import React from "react";

const RailwayDivider = ({ className = "", color = "#3E5F44" }) => (
  <div
    className={`w-full ${className}`}
    aria-hidden="true"
    style={{
      height: 2,
      backgroundImage: `repeating-linear-gradient(to right, ${color} 0, ${color} 12px, transparent 12px, transparent 20px)`,
    }}
  />
);

export default RailwayDivider;
